import { createElement } from 'react';
import { Box } from '@chakra-ui/react';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["children", "active", "cardLineColor"];

var Card = function Card(_ref) {
  var children = _ref.children,
      active = _ref.active,
      cardLineColor = _ref.cardLineColor,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var activeStyles = {
    border: '0'
  };

  if (active) {
    activeStyles.border = '2px';
  }

  return createElement(Box, Object.assign({
    boxShadow: "rgb(37 40 42 / 20%) 0px 2px 4px 0px",
    padding: "2",
    position: "relative"
  }, activeStyles, {
    borderTop: "2px",
    borderColor: cardLineColor
  }, props, {
    "data-testid": 'card-wrapper-test-id'
  }), children);
};

export default Card;